// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__37Rdp","changeCardLabel":"Settings_changeCardLabel__vt5ef","secondaryText":"Settings_secondaryText__BomPc"};